import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fire } from "./Firebase/firebase";
import { Redirect } from "react-router-dom";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      user: null,
      loading: true,
      isLoggedIn: false,
      loginError: ""
    };
    this.login = this.login.bind(this);
  }

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
  };

  login() {
    fire
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(user => {
        this.setState({user: user})
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loginError: error + " Please try again!"
        });
      });
  }

  render() {
    if (this.props.authenticated === true) {
      return (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: { authenticated: this.props.authenticated }
          }}
        />
      );
    }

    return (
      <div>
        <div className="login">
          <h1 className="text-center" id="landing-title">
            Welcome to <br />
            PuppyMap
          </h1>
          <form onSubmit={this.handleSubmit}>
            <div id="error">
              <p>{this.state.loginError}</p>
            </div>
            <FormGroup controlId="email" bsSize="large">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                className="input-hover"
                autoFocus
                id="email"
                //value={this.state.email}
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup controlId="password" bsSize="large">
              <ControlLabel>Password</ControlLabel>
              <FormControl
                className="input-hover"
                //value={this.state.password}
                id="password"
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <Button
              className="button-hover"
              bsSize="large"
              onClick={this.login}
              type="submit"
            >
              Go!
            </Button>
            <Link to="./register" id="register-link">
              {" "}
              Don't have an account? Register!{" "}
            </Link>
          </form>
        </div>
      </div>
    );
  }
}
